/**
 * GIF Maker Module
 * Plays a sequence of images in rapid succession like an animated GIF
 * Supports very fast frame rates (up to 60fps / ~16ms intervals)
 */

(function() {
  'use strict';

  function GifMaker(container) {
    this.container = container;
    this.frame = container.querySelector('[data-gif-frame]');
    this.images = Array.from(container.querySelectorAll('[data-gif-image]'));
    this.playBtn = container.querySelector('[data-gif-play]');
    this.pauseBtn = container.querySelector('[data-gif-pause]');
    
    this.interval = parseInt(container.dataset.gifInterval, 10) || 100;
    this.autoplay = container.dataset.gifAutoplay !== 'false';
    this.currentIndex = 0;
    this.isPlaying = false;
    this.animationId = null;
    this.lastFrameTime = 0;

    if (this.images.length < 2) return;

    this.bindEvents();
    
    if (this.autoplay) {
      this.play();
    }
  }

  GifMaker.prototype.bindEvents = function() {
    var self = this;

    if (this.playBtn) {
      this.playBtn.addEventListener('click', function() {
        self.play();
      });
    }

    if (this.pauseBtn) {
      this.pauseBtn.addEventListener('click', function() {
        self.pause();
      });
    }

    // Pause on visibility change to save resources
    document.addEventListener('visibilitychange', function() {
      if (document.hidden && self.isPlaying) {
        self.pause();
        self._wasPlaying = true;
      } else if (!document.hidden && self._wasPlaying) {
        self.play();
        self._wasPlaying = false;
      }
    });

    // Pause when out of viewport (Intersection Observer)
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting && self.isPlaying) {
            self.pause();
            self._wasVisible = true;
          } else if (entry.isIntersecting && self._wasVisible) {
            self.play();
            self._wasVisible = false;
          }
        });
      }, { threshold: 0.1 });

      this.observer.observe(this.container);
    }
  };

  GifMaker.prototype.play = function() {
    if (this.isPlaying) return;
    
    this.isPlaying = true;
    this.updateControls();
    this.lastFrameTime = performance.now();
    this.animate();
  };

  GifMaker.prototype.pause = function() {
    this.isPlaying = false;
    this.updateControls();
    
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }
  };

  GifMaker.prototype.animate = function() {
    var self = this;
    
    if (!this.isPlaying) return;

    this.animationId = requestAnimationFrame(function(timestamp) {
      var elapsed = timestamp - self.lastFrameTime;

      if (elapsed >= self.interval) {
        self.nextFrame();
        self.lastFrameTime = timestamp - (elapsed % self.interval);
      }

      self.animate();
    });
  };

  GifMaker.prototype.nextFrame = function() {
    // Hide current
    this.images[this.currentIndex].style.display = 'none';
    
    // Advance index
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    
    // Show next
    this.images[this.currentIndex].style.display = 'block';
  };

  GifMaker.prototype.updateControls = function() {
    if (this.playBtn && this.pauseBtn) {
      this.playBtn.style.display = this.isPlaying ? 'none' : 'block';
      this.pauseBtn.style.display = this.isPlaying ? 'block' : 'none';
    }
  };

  GifMaker.prototype.destroy = function() {
    this.pause();
    if (this.observer) {
      this.observer.disconnect();
    }
  };

  // Initialize all gif makers
  function initAllGifMakers() {
    document.querySelectorAll('[data-gif-maker]').forEach(function(container) {
      if (!container._gifMaker) {
        container._gifMaker = new GifMaker(container);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGifMakers);
  } else {
    initAllGifMakers();
  }

  // Shopify theme editor integration
  document.addEventListener('shopify:section:load', function(event) {
    event.target.querySelectorAll('[data-gif-maker]').forEach(function(container) {
      if (container._gifMaker) {
        container._gifMaker.destroy();
      }
      container._gifMaker = new GifMaker(container);
    });
  });

  document.addEventListener('shopify:section:unload', function(event) {
    event.target.querySelectorAll('[data-gif-maker]').forEach(function(container) {
      if (container._gifMaker) {
        container._gifMaker.destroy();
      }
    });
  });

})();
